/*--------------------------------------------------------------
# Custom scripts for Card carousel block
--------------------------------------------------------------*/

const logoSlider = document.querySelectorAll('.logo-carousel .swiper');
const logoSliderPagination = document.querySelectorAll('.card-swiper-pagination');
const logoSliderNext = document.querySelectorAll('.card-swiper-next');
const logoSliderPrev = document.querySelectorAll('.card-swiper-prev');

for( i = 0; i < logoSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    logoSlider[i].classList.add('swiper-' + i);
    // logoSliderPagination[i].classList.add('card-swiper-pagination-' + i);
    logoSliderNext[i].classList.add('card-swiper-next-' + i);
    logoSliderPrev[i].classList.add('card-swiper-prev-' + i);

    var initlogoSlider = new Swiper('.logo-carousel .swiper-' + i, {
        simulateTouch: false,
        grabCursor: false,
        slidesPerView: 1.1,
        spaceBetween: 24,
        // Pagination toggle buttons
        // pagination: {
        //     el: '.card-swiper-pagination-' + i,
        //     clickable: true,
        // },
        // Navigation arrows
        navigation: {
            nextEl: '.card-swiper-next-' + i,
            prevEl: '.card-swiper-prev-' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 3,
                slidesPerGroup: 1, // how many to slide at a time
            },
            768: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 5,
            },
            1200: {
                slidesPerView: 6,
            }
        }
    });
}
